module.exports = __webpack_public_path__ + "static/media/federico1.dcf1b82e.jpg";